export default {
  VIEW_MODES: {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
  },
  EDITOR_MODES: {
    PREVIEW: 'preview',
    QUICK_PREVIEW: 'quickPreview',
    EDITOR: 'editor',
  },
  KNOB_DIRECTIONS: {
    TOP_LEFT: 'knobTopLeft',
    TOP_RIGHT: 'knobTopRight',
    MIDDLE_LEFT: 'knobMiddleLeft',
    MIDDLE_RIGHT: 'knobMiddleRight',
    BOTTOM_LEFT: 'knobBottomLeft',
    BOTTOM_RIGHT: 'knobBottomRight',
    TOP_MIDDLE: 'knobTopMiddle',
    BOTTOM_MIDDLE: 'knobBottomMiddle',
  },
  KEYS: {
    BACKSPACE: 8,
    ARROW_RIGHT: 39,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_DOWN: 40,
    ENTER: 13,
    ESC: 27,
  },
  DRAGGABLE_ITEM_TYPES: {
    ADD_PANEL_ELEMENT: 'add-panel-element',
  },
  TEXT_ALIGN: {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
  },
  MOBILE_WIDTH: 320,
  MOBILE_CONTENT_WIDTH: 320,
  MOBILE_MIN_HEIGHT: 500,
  DESKTOP_MIN_WIDTH: 750,
  DESKTOP_MAX_WIDTH: 950,
  DESKTOP_MIN_HEIGHT: 500,
  DESKTOP_DEFAULT_HEIGHT: 720,
  MOBILE_DEFAULT_HEIGHT: 500,
  HEADER_HEIGHT: 166,
  TOP_PADDING_FROM_TOOLBAR: 25,
  BOTTOM_PADDING_FROM_VIEW: 35,
  EDITOR_APP_WRAPPER_ID: 'editor-app-wrapper',
  EDITOR_CONTAINER_ID: 'editor-container',
  EDITOR_TOOLBAR_ID: 'editor-toolbar',
  EDITOR_MAIN_WRAPPER_ID: 'editor-main-wrapper',
  EDITOR_TEMPLATE_WRAPPER_ID: 'editor-template-wrapper',
  EDITOR_STAGE_ID: 'editor-stage',
  DESKTOP_WRAPPER_ID: 'desktop-wrapper',
  DESKTOP_RENDERER_ID: 'desktop-renderer',
  DESKTOP_VIEW_ID: 'desktop-view',
  MOBILE_WRAPPER_ID: 'mobile-wrapper',
  MOBILE_VIEW_ID: 'mobile-view',
  MOBILE_RENDERER_ID: 'mobile-renderer',
  MOBILE_OPTIMIZED_TOGGLE: 'mobile-optimized-toggle',
  VIEW_MODES_SWITCH_ID: 'view-modes-switch',
  MOUSE_CATCHER_ID: 'mouse-catcher',
  EDIT_BOX_ID: 'edit-box',
  FLOATING_PANEL_ID: 'floating-panel',
  EDITOR_DESKTOP_PROPERTIES_MENU_ID: 'editor-desktop-properties-menu',
  EDITOR_MOBILE_LEFT_BAR_MENU_ID: 'editor-mobile-left-bar',
  EDITOR_DESKTOP_LEFT_BAR_MENU_ID: 'editor-desktop-left-bar',
  EDITOR_DESKTOP_LEFT_BAR_MENU_ELEMENTS_ID: 'editor-desktop-left-bar-elements',
  EDITOR_MOBILE_PROPERTIES_MENU_ID: 'editor-mobile-properties-menu',
  MOBILE_ELEMENT_CONTROLS_ID: 'editor-mobile-element-controls-menu',
  DESKTOP_ELEMENT_CONTROLS_ID: 'editor-desktop-element-controls-menu',
  EDITOR_SAVE_BUTTONS_ID: 'editor-save-buttons',
  PREVIEW_BUTTON_ID: 'preview-button',
  EDITOR_UNDO_REDO_BUTTONS_ID: 'editor-undo-redo-buttons',
  HOVER_BOX_ID: 'hover-box',
  GLOBAL_CONTROLS: 'global-controls',
  ADDED_ELEMENT_ANIMATION_DURATION: 450,
  GALLERY_THUMBNAIL_ROW_TRANSITION_DURATION: 200,
  VERTICAL_TAB_TRANSITION_DURATION: 300,
  SPACE_BETWEEN_MOBILE_ELEMENTS: 10,
  CONTAINING_MOBILE_ELEMENT_BOUNDRIES: 10,
  CONTAINED_ELEMENT_OVERFLOW_TOLERANCE: 0.1,
  ADD_MOBILE_ELEMENTS_FIRST_STEP: 1,
  ADD_MOBILE_ELEMENTS_SECOND_STEP: 2,
  ADD_MOBILE_ELEMENTS_THIRD_STEP: 3,
  MINIMUM_MOBILE_FONT_SIZE: 16,
  WALK_THROUGH_BEACONS_LOCAL_STORAGE_ID: 'walk_through_beacons',
  WALK_THROUGH_AUTO_START_LOCAL_STORAGE_ID: 'walkThroughAutoStart',
  ON_BOARDING_DIALOG_NAME: 'onBoarding',
  ON_BOARDING_DIALOG_WITH_VIDEO_NAME: 'onBoardingWithVideo',
};
